import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import didInsert from 'webapp/modifiers/did-insert';
import CommonUiIcon from 'webapp/components/common/ui-icon';
import OnboardingGuidedTourSteps from 'webapp/components/onboarding/guided-tour/steps';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButton from 'webapp/components/submit-button';

export default class OnboardingGuidedTourPopupEndComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('navigation') declare navigationService: Service.Navigation;

	@action
	setupView(node: HTMLElement) {
		const options = {
			numberOfPieces: 100,
			gravity: 0.05,
			opacity: 0.7,
		};

		const confetti = window.Confetti.create(node, options);
		confetti.start();

		this.analyticsService.event(TrackingEvent.GUIDED_ONBOARDING_TOUR_STEP_COMPLETED, {
			level: 'completed',
		});
	}

	@action
	triggerAction() {
		this.navigationService.transitionToRoute('index');
	}

	<template>
		<div class="title title--vertical">
			<canvas {{didInsert this.setupView}} />
			<CommonUiIcon @name="DataboxLogo" @size="lg" />
		</div>

		<div class="content">
			<OnboardingGuidedTourSteps @allFulfilled={{true}} />

			<h2>Congrats! You’ve successfully completed all steps</h2>
			<p>
				Now you know how to bring all your data together and build custom dashboards to
				visualize your performance in real-time.<br />
				Next, we'll show you how to report your performance automatically, and use your data
				to make better decisions.
			</p>

			<div class="controls2 controls2--center">
				<SubmitButton
					@text="Check what is next"
					@size="big"
					@onTrigger={{this.triggerAction}}
				/>
			</div>
		</div>
	</template>
}
